export default __webpack_public_path__ + "static/media/9.75cdb8b6.jpg";